<template>
    <div>
        <div class="c-block__headings">
            <h1 class="ios-title u-mt-0">閲覧履歴一覧</h1>
            <div class="is-pc toggle-button-wrapper" v-if="showHistoryPaginator">
                表示切替：
                <div class="c-toggle-buttons">
                    <button class="c-toggle-buttons_item list is-active" @click="showList">
                        <span class="c-icon is-list-view is-current-color"></span>
                    </button>
                    <button class="c-toggle-buttons_item tile" @click="showTile">
                        <span class="c-icon is-grid-view is-current-color"></span>
                    </button>
                </div>
            </div>
        </div>

        <div v-show="!loading">
            <div id="cat1" v-if="showHistoryPaginator">
                <div class="product-book-container is-list">
                    <template v-for="item in historyPaginator">
                        <degital-book-block :item='item' :route_list='route_list' :is_plus='is_plus'></degital-book-block>
                    </template>
                </div>
                <div class="product-book-container is-list" v-html="paginatorHtml"></div>
            </div>
            <div class="text-center empty_notify" v-else>
                <p>閲覧履歴はありません。</p>
            </div>
        </div>
    </div>
</template>

<script>
    import axios from 'axios';
    import routeMixin from '../../mixins/route.js';

    export default {
        props: [
            'route_list',
            'is_plus',
            'page_num',
        ],
        data() {
            return {
                historyPaginator: [],
                paginatorHtml: null,
                loading: true,
            }
        },
        mixins: [routeMixin],
        computed: {
            showHistoryPaginator: function () {
                return this.historyPaginator.length > 0;
            },
        },
        methods: {
            showList() {
                document.getElementsByClassName('c-toggle-buttons_item tile')[0].classList.remove('is-active');
                document.getElementsByClassName('c-toggle-buttons_item list')[0].classList.add('is-active');
                document.getElementsByClassName('product-book-container')[0].classList.remove('is-tile');
                document.getElementsByClassName('product-book-container')[0].classList.add('is-list');
            },
            showTile() {
                document.getElementsByClassName('c-toggle-buttons_item list')[0].classList.remove('is-active');
                document.getElementsByClassName('c-toggle-buttons_item tile')[0].classList.add('is-active');
                document.getElementsByClassName('product-book-container')[0].classList.remove('is-list');
                document.getElementsByClassName('product-book-container')[0].classList.add('is-tile');
            },
        },
        created() {
            let histories = historyJson.histories;
            let url = this.route(this.route_list, 'site.api.history');
            axios.post(url, {
                params: {
                    histories: histories,
                    pageNum: this.page_num,
                }
            }).then(res => {
                this.historyPaginator = res.data.data.historyPaginator.data;
                this.paginatorHtml = res.data.data.paginatorHtml;
                this.loading = false;
            }).catch(error => {
            });
        },
    }
</script>
